import Icons from '../components/Icons';
import HomeShiba from "../components/HomeShiba";

function Home() {
    return (
    <>
        <h1>Hi, I'm Mikołaj!</h1>
        <div>
            <h2>Full-stack developer</h2>
            <div className='underline'></div>
        </div>
        <Icons />
        <HomeShiba />
    </>
    );
}

export default Home;
